module.exports = __webpack_public_path__ + "static/media/previous.78b351fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/com/sixdee/crbtportal/ui/toolkit/carousel/previous.svg
// module id = 1081
// module chunks = 0